import { render } from "./nuezGUI.vue?vue&type=template&id=265ffc8f"
import script from "./nuezGUI.vue?vue&type=script&lang=js"
export * from "./nuezGUI.vue?vue&type=script&lang=js"
script.render = render

export default script